module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenLite.min.js");;